
import { AccountStatus } from "@enums/account/AccountStatus";
import { AccountFeatures } from "@enums/account/AccountFeature";
import { SpecialUserPermissions } from "@enums/SpecialUserPermissions";
import { UserAccessPermissions } from "@enums/UserAccessPermissions";
import { UserStatus, UserType, AccountUserType } from "@enums/UserType";
import { IReseller } from "@app/main/modules/foundation/_models/IReseller";

export interface IAccountUserMapping {
    Id?: number;
    UserId?: number;
    AccountId: number;

    Name?: string; // name
    Phone?: string;

    Type?: AccountUserType;

    Status: UserStatus;
    AccountStatus?: AccountStatus;

    ReadFeatures: AccountFeatures;
    ManageFeatures: AccountFeatures;
    SpecialUserPermissions: SpecialUserPermissions;

    AccessMask: UserAccessPermissions;

    AllowAllVehicles?: boolean;
    AllowAllDrivers?: boolean;
    AllowAllGeofences?: boolean;

    Created?: string;
    Updated?: string;

    //--

    resellers?: IReseller[];
}

export interface IUserDriverMapping {

    Id: number,
    DriverId?: number,
    UserId?: number

}

export interface IUserVehicleMapping {

    Id: number,
    VehicleId?: number,
    UserId?: number

}

export interface IUserGeofenceMapping {

    Id: number,
    GeofenceId?: number,
    UserId?: number

}

export interface IGroupUserMapping {

    Id: number,
    GroupId: number,
    UserId: number

}
export enum UserPlatform {
    Valkyrie,
    Foundation
}

export interface IUser {
    Id?: number;
    Type?: UserType;
    IsActive?: boolean;
    Description?: string;
    IsSystemUser?: boolean;
    IsReseller?: boolean;

    ResellerIds?: number[];
    UserGroupId?: number;

    AccountUserMappings?: IAccountUserMapping[];
    CurrentAccountUserMapping?: IAccountUserMapping;

    Email?: string;

    ResetPassword?: boolean;

    FailedLoginAttempts?: number;
    FirstFailedLoginAttempt?: Date;
    UserLockedUntil?: Date;

    VehicleIds?: number[];
    DriverIds?: number[];
    GeofenceIds?: number[];
    GroupIds?: number[];

    // ---

    lastLoggedIn?: Date;
    language?: boolean;
    platform?: UserPlatform;

    newUserLanguageCode?: string;
}
